module.exports = __webpack_public_path__ + "static/media/people-dining2.48144338.jpg";